const client_link_type = {
    'ACCOUNT': 'account',
    'LOCAL': 'local',
    'DOSSIER': 'dossier',
    'USER': 'user'
};

export default client_link_type;
